import axios from "axios";

const service = axios.create({
  baseURL: window.phConfig.VUE_PC_BASE_API,
  timeout: 2000,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // config.headers['Access-Token'] = sessionStorage.getItem('token');
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["Access-Token"] =
      sessionStorage.getItem("token") || window.phConfig.VUE_PC_TOKEN;
    return config;
  },

  (error) => {
    // do something with request error
    return Promise.reject(error, "error");
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;

    // console.log(response, "response")
    // if (response.status == 302) {
    //     window.location.reload();
    // }
    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 20000) {
    //     Toast({
    //     message: res.message || 'Error',
    //     forbidClick: true,
    //     duration: 5 * 1000
    //   })

    //   // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // to re-login
    //     Dialog.confirm({
    //       title: "确认登出",
    //       message: "You have been logged out, you can cancel to stay on this page, or log in again"
    //     }).then(() => {
    //         // on confirm
    //     }).catch(() => {
    //         // on cancel
    //     });
    //   }
    //   return Promise.reject(new Error(res.message || 'Error'))
    // } else {
    //   return res
    // }
    return res;
  },
  (error) => {
    console.log("err" + error); // for debug

    if (error.response.status == 403) {
      window.location.reload();
    }

    // 给axios 添加isGhost自定义属性配置项  来配置是否展示错误提示Toast
    // 如果没配置说是静默请求  弹提示框
    if (!error || !error.config || !error.config.isGhost) {
      /*  Toast({
                  message: error.message,
                  forbidClick: true,
                  duration: 5 * 1000
              })*/
    }

    return Promise.reject(error);
  }
);

export default service;
